import {
  FETCH_USERS,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILURE,
  DEACTIVATE_USER,
  DEACTIVATE_USER_SUCCESS,
  DEACTIVATE_USER_FAILURE,
  REACTIVATE_USER,
  REACTIVATE_USER_SUCCESS,
  REACTIVATE_USER_FAILURE,
} from './constants';

export function fetchUsers() {
  return { type: FETCH_USERS };
}

export function fetchUsersSuccess(users) {
  return { type: FETCH_USERS_SUCCESS, users };
}

export function fetchUsersFailure(error) {
  return { type: FETCH_USERS_FAILURE, error };
}

export function deactivateUser(userId) {
  return { type: DEACTIVATE_USER, userId };
}

export function deactivateUserSuccess() {
  return { type: DEACTIVATE_USER_SUCCESS };
}

export function deactivateUserFailure(error) {
  return { type: DEACTIVATE_USER_FAILURE, error };
}

export function reactivateUser(userId) {
  return { type: REACTIVATE_USER, userId };
}

export function reactivateUserSuccess() {
  return { type: REACTIVATE_USER_SUCCESS };
}

export function reactivateUserFailure(error) {
  return { type: REACTIVATE_USER_FAILURE, error };
}
